import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {Router} from "@angular/router";
import { ModalIframeService } from "../../../../common/iframe/modal-iframe.service";
import { UserService } from "../../../../injections/user.service";

@Component({
    selector: 'user-payment',
    templateUrl: '../../templates/partials/user-payment.html'
})

export class UserPaymentComponent implements OnInit {
    
    @Input() data;
    @Output() mandateEmitter = new EventEmitter();
    public mandateData = null;
    public showMandateMessage = false;
    public enableButtonRenew = false;
    public disableCreateMangoPay = false;
    public disableCheckMandate = false;
    public disableRenewMandate = false;
    constructor(private modalIframeService: ModalIframeService, private userService: UserService) { }

    public showModalIframe(){
        this.modalIframeService.openModalIframe();
    }

    public createMangoPayData(type) {
            this.disableCreateMangoPay = true;
            
    }

    public checkMandateMangoPay() {
        this.disableCheckMandate = true;
    
    }

    public renewMandate() {
        this.disableRenewMandate = true;
    }

    private openConfirmation(url: string) {
        this.showModalIframe();
        window.open(url, "_blank");
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/users/components/dummy/user-payment.component.ts